type MergeVersion = "OLD" | "NEW";

const mergeOptionKeys: MergeVersion[] = ["OLD", "NEW"];

const isMergeVersion = (value: string): value is MergeVersion => {
  return mergeOptionKeys.indexOf(value as MergeVersion) > -1;
};

const getMergeVersion = () => {
  return [...mergeOptionKeys];
};

const getMergeVersionDisplayValue = (key: MergeVersion): string => {
  switch (key) {
    case "NEW":
      return "New";
    case "OLD":
      return "Old";
    default:
      throw new Error(`Value ${key} is not a MergeVersion`);
  }
};

export {
  MergeVersion,
  isMergeVersion,
  getMergeVersion,
  getMergeVersionDisplayValue,
};
